import { MinimalFormField } from "../types/form-fields";
import { Resolver } from "../types/resolver";

export const mapResolvers = (resolvers: Resolver<MinimalFormField>[]) =>
  Object.fromEntries(resolvers.map((r) => [r.type, r]));
